<script>
export default {
  name: 'AppTable',

  props: {
    content: {
      type: Object,
      required: true,
    },
  },
};
</script>

<template>
  <div class="table-wrapper">
    <h6 class="header">{{ content.title }}</h6>
    <table cellspacing="0">
      <tr v-for="(row, i) in content.data.tableData" :key="i">
        <td v-for="(data, j) in row" :key="j">
          {{ data }}
        </td>
      </tr>
    </table>
  </div>
</template>

<style lang="scss" scoped>
.table-wrapper {
  max-width: $text-block-width;

  .header {
    @include secondary-text-bold;
    padding: $space-12 $space-16;
    background-color: $background-color-secondary;
    border: 1px solid $separator-color;
    color: $text-color-secondary;
    border-top-left-radius: $border-radius-xx-small;
    border-top-right-radius: $border-radius-xx-small;
    margin: 0;
  }

  table {
    @include caption-regular;
    width: 100%;
    padding: $space-16;
    border: 1px solid $separator-color;
    border-top: none;
    border-bottom-left-radius: $border-radius-xx-small;
    border-bottom-right-radius: $border-radius-xx-small;

    @include tablet-large {
      padding: $space-24;
    }

    tr {
      width: 100%;

      td {
        border-bottom: 1px solid $separator-color;
        padding: $space-12 $space-8;
        vertical-align: baseline;

        @include tablet-large {
          padding: $space-12;
        }

        &:first-of-type {
          text-align: right;
          color: $text-color-primary;
          font-weight: $font-weight-bold;
          padding-left: 0;

          @include tablet-small {
            white-space: nowrap;
          }
        }

        &:last-of-type {
          width: inherit;
          word-break: break-word;
          padding-right: 0;
        }
      }

      &:first-of-type {
        td {
          padding-top: 0;
        }
      }

      &:last-of-type {
        td {
          padding-bottom: 0;
          border-bottom: none;
        }
      }
    }
  }
}

@media print {
  .api-reference-table {
    break-inside: avoid;

    .header {
      print-color-adjust: exact;
    }
  }
}
</style>
